import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close.svg",
  "use": "close.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.285 20.38a.97.97 0 001.377 0l6.671-6.67 6.671 6.67a.97.97 0 001.377 0 .974.974 0 000-1.376l-6.67-6.67 6.67-6.672a.974.974 0 10-1.377-1.377l-6.67 6.671-6.672-6.67a.974.974 0 10-1.377 1.376l6.671 6.671-6.67 6.67a.974.974 0 000 1.378z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol